import { type Meta } from '../types/docs';

const META: Meta = {
  description:
    'A smart resize generation was kicked off, including the sizes chosen. Fires when the user clicks Generate in the size picker and when a resize is queued automatically (canvas empty state, Resize for [set name] from Edit in Canvas).',
  name: 'canvas_smart_resize_generated',
  params: [
    {
      description: 'The id of the canvas',
      name: 'canvas_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The type of node the smart resize was generated on',
      name: 'node_type',
      required: true,
      type: 'enum',
      values: ['image', 'video'],
    },
    {
      description: 'The preset format ids that were selected (custom sizes are excluded)',
      name: 'format_ids',
      required: true,
      type: 'array',
      values: [
        'instagram_feed_portrait',
        'instagram_feed_square',
        'instagram_feed_landscape',
        'instagram_reel',
        'instagram_story',
        'facebook_feed_portrait',
        'facebook_feed_square',
        'facebook_feed_landscape',
        'facebook_stories',
        'facebook_reels',
        'facebook_in_stream_video',
        'tiktok_standard',
        'tiktok_square',
        'tiktok_landscape',
        'snapchat_story',
        'snapchat_spotlight',
        'youtube_standard_video',
        'youtube_shorts',
        'youtube_thumbnail',
        'linkedin_feed_portrait',
        'linkedin_feed_square',
        'linkedin_feed_landscape',
        'linkedin_video_vertical',
        'linkedin_cover_banner',
        'x_single_image',
        'x_in_stream_square',
        'x_in_stream_landscape',
        'x_header_banner',
      ],
    },
    {
      description: 'The distinct platforms that were selected (custom sizes report as "custom")',
      name: 'platforms',
      required: true,
      type: 'array',
      values: ['instagram', 'facebook', 'tiktok', 'snapchat', 'youtube', 'linkedin', 'x', 'custom'],
    },
    {
      description: 'The total number of formats selected (preset formats plus custom sizes)',
      name: 'format_count',
      required: true,
      type: 'number',
    },
    {
      description: 'The number of custom (user-defined width x height) sizes selected',
      name: 'custom_size_count',
      required: true,
      type: 'number',
    },
    {
      description:
        'Where the resize was started (a subset of canvas_agent_chat_prompt_sent.source values). "edit_in_canvas" covers the Resize for [set name] auto-run and any size picker opened from an Edit in Canvas menu handoff; "empty_state" is the canvas empty-state auto-run; "canvas_toolbar" is the size picker opened on the canvas.',
      name: 'source',
      required: true,
      type: 'enum',
      values: ['canvas_toolbar', 'edit_in_canvas', 'empty_state'],
    },
    {
      description:
        'True when the resize was queued automatically (canvas empty state, or Resize for [set name] with 10 sizes or fewer) rather than started from Generate in the size picker. Resize for [set name] with more than 10 sizes opens the picker with the set selected, so it reports false with source edit_in_canvas',
      name: 'auto_run',
      required: true,
      type: 'boolean',
    },
    {
      description:
        'The id of the saved size set the run came from: an auto-run, or a size picker that opened with the set preselected and still had all of it selected at Generate',
      name: 'size_set_id',
      required: false,
      type: 'string',
    },
  ],
};

export default META;
